//Built-in libraries

//Third party libraries

//Custom components
import { HookInput } from 'components/UI/HookForm/Form/Input';
import Button from 'components/UI/Button';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';
import { HookSelect } from 'components/UI/HookForm/Form/Select';
import HookMaskedInput from 'components/UI/HookForm/Form/MaskedInput';
import { States } from '../../../../../../constants';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function PropertyInformation() {
  const { setCurrentStep, data } = useApplicationFormContext();
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue('propertyInformation.city', 'Birmingham');
    setValue('propertyInformation.state', 'Alabama');
  }, []);

  return (
    <div className="sm:rounded-r-md sm:overflow-hidden">
      <div className="py-6 px-4 space-y-6 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-green-500">
          Property Information
        </h3>
        <div className="my-5 font-semibold">
          <h4>Add the Property Information for the down payment assistance</h4>
        </div>
        <div className="grid grid-cols-6 gap-6">
          <HookInput
            customClassName="col-span-4"
            label="Property Address"
            name="propertyInformation.streetAddress"
            type="text"
          />
          <div></div>
          <HookInput
            customClassName="col-span-6 sm:col-span-6 lg:col-span-2"
            label="City"
            name="propertyInformation.city"
            type="text"
            disabled
          />
          <HookSelect
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="State"
            name="propertyInformation.state"
            disabled
            options={States.map((s) => ({ label: s.name, value: s.name }))}
          />

          <HookInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Zip / Postal Code"
            name="propertyInformation.zipCode"
            type="number"
          />
          <HookMaskedInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="House Price"
            name="propertyInformation.housePrice"
            id="propertyInformation.housePrice"
            maskedComponent="currency"
          />
          <div className="col-span-4"></div>
          <HookInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Buyers Agent Name"
            name="propertyInformation.buyersAgentName"
            type="text"
          />
          <HookMaskedInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Work Phone"
            name="propertyInformation.buyersWorkPhone"
            maskedComponent="phone"
          />

          <HookInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Buyers Agent Email"
            name="propertyInformation.buyersAgentEmail"
            id="propertyInformation.buyersAgentEmail"
            type="email"
          />
          <div className="my-5 col-span-6">
            <h4 className="font-semibold">Sellers Information</h4>
          </div>
          <HookInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Sellers Name"
            name="propertyInformation.sellersName"
            type="text"
          />
          <HookInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Sellers Agent Name"
            name="propertyInformation.sellersAgentName"
            type="text"
          />
          <HookMaskedInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Work Phone"
            name="propertyInformation.sellersWorkPhone"
            maskedComponent="phone"
          />

          <HookInput
            customClassName="col-span-6 sm:col-span-3 lg:col-span-2"
            label="Sellers Agent Email"
            name="propertyInformation.sellersAgentEmail"
            id="propertyInformation.sellersAgentEmail"
            type="email"
          />
        </div>
        <div className="flex gap-4 justify-end mt-5">
          <Button
            label="Previous"
            btnStyle="neutral"
            type="button"
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button label="Next" btnStyle="primary" type="submit" />
        </div>
      </div>
    </div>
  );
}
